import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { restaurarPaleta } from './nucleo/paleta';
import './estilos/globais.css';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('O elemento #raiz não está no index.html.');

// Antes do primeiro quadro, como o `AppPalette.restaurar()` do
// `app_bootstrap.dart`: a cor certa já na primeira pintura, sem piscar.
restaurarPaleta();

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
